<template>
  <v-dialog
    v-model="opened"
    width="400"
    persistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card block flat>
      <v-card-title>
        <span class="title">Edit Due Dates</span>
        <v-spacer />
      </v-card-title>

      <v-card-text>
        <v-layout column>
          <v-layout class="text-xs-left">
            <v-flex xs12 class="pr-2">
              <div>
                Due Date<v-tooltip top
                  ><v-icon slot="activator" size="15" class="ml-1">info</v-icon
                  ><span
                    >Reminders will be sent out automatically to incomplete
                    questionnaire approaching the due date</span
                  ></v-tooltip
                >
              </div>

              <v-text-field
                class="default-input body-1 m-0"
                type="date"
                solo
                :rules="rules.dueDateRules"
                v-model="dueDate"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          class="primary text-none"
          :disabled="!savable || savingQuestionnaires"
          :loading="savingQuestionnaires"
          @click="saveQuestionnaires()"
        >
          Save
        </v-btn>

        <v-btn
          class="error--text text-none"
          flat
          @click="$emit('update:opened', false)"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import API from '@/api';
import moment from 'moment';
import { rules } from '@/constants/variables';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    selectedQuestionnaires: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      dueDate: '',
      rules,
      savingQuestionnaires: false,
    };
  },

  methods: {
    getFirstDueDate(questionnaires) {
      if (!questionnaires) return null;
      if (questionnaires.length === 0) return null;
      if (!questionnaires[0].due_date) return null;

      return questionnaires[0].due_date;
    },

    reset() {
      this.dueDate = '';
    },

    async saveQuestionnaires() {
      this.savingQuestionnaires = true;

      try {
        const response = await API.questionnaire.saveQuestionnaires({
          questionnaireIds: this.selectedQuestionnaires.map(q => q.id),
          dueDate: this.dueDate,
        });

        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'You have saved the questionnaires.',
          });
          this.$emit('update:opened', false);
          this.$emit('refresh-questionnaires');
        }
      } catch (e) {
        console.log(e);
        // Sending a Sentry message because if this does fail during the API call,
        // it's likely that we messed something up, not them.
        Sentry.captureMessage(
          'selected questionnaires failed to update (in EditDueDateDialog)',
          { error: e, message: e.error_message },
        );
      }

      this.savingQuestionnaires = false;
    },
  },

  computed: {
    savable() {
      return !this.dueDate || moment() < moment(this.dueDate);
    },
  },

  created() {
    this.dueDate = this.getFirstDueDate(this.selectedQuestionnaires);
  },

  watch: {
    opened(newVal) {
      if (!newVal) {
        this.reset();
      }
    },

    selectedQuestionnaires(newVal) {
      this.dueDate = this.getFirstDueDate(newVal);
    },
  },
};
</script>
